import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/vars';

  .DayPicker_weekHeader {
    top: 65px;
    z-index: 0;
  }

  .DayPicker_weekHeader_li {
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
  }

  .DayPicker_weekHeader_li {
    margin: 0 !important;
  }

  .DayPickerKeyboardShortcuts_buttonReset {
    display: none;
  }

  .SingleDatePickerInput__withBorder {
    border: none;
  }

  .DateInput_input__focused {
    border: none;
  }

  .DateInput,
  .SingleDatePickerInput,
  .SingleDatePicker {
    width: 100% !important;
  }

  .SingleDatePicker_picker {
    z-index: 999 !important;
    top: 65px !important;
    @include respond-to(xl) {
      left: -50px !important;
    }
    @include respond-to(md) {
      left: -80px !important;
    }
    @include respond-to(sm) {
      left: -30px !important;
    }
  }

  .DayPickerNavigation_button {
    z-index: 6;
    &:first-child {
      left: 10px;
    }
    &:last-child {
      right: 10px;
    }
  }

  .DateInput_input {
    font-weight: 400;
    font-size: inherit;
    padding: rem(23px 32px 5px 13px);
    box-shadow: none;
    transition: none;
    border: none;
    opacity: 1 !important;
    height: rem(52px);
    &::placeholder {
      opacity: 1 !important;
    }
  }

  .DateInput_input__focused {
    border: none;
    box-shadow: none;
  }

  .DateField__inner {
    margin-bottom: 10px;
    position: relative;
  }

  .DateField {
    direction: ltr;
    position: absolute;
    z-index: 10;
  }

  .DateField__years-navigation {
    display: flex;
    justify-content: space-between;
    width: 68%;
    margin: 0 auto;
    align-items: center;
    select {
      border: none;
      background: none;
    }
    .Select__value-container {
      padding: 0 !important;
      width: 110px;
    }
    .Select__control {
      border: none;
    }
    .Select__menu {
      z-index: 10 !important;
    }
    .Select__option {
      padding: rem(10px 5px) !important;
    }
    .DateField__month-inner {
      > div {
        width: 110px;
      }
    }
    .DateField__years-inner {
      > div {
        width: 70px;
      }
    }
  }

  .CalendarMonth_caption {
    font-size: rem(15px);
    width: 280px;
    position: relative;
  }

  .DateInput_input__disabled {
    font-style: normal;
  }

  .CalendarMonth_table {
    position: relative;
    top: 30px;
  }

  .DayPicker_transitionContainer {
    height: 350px !important;
  }

  .CalendarMonth {
    height: 250px !important;
  }

  .CalendarMonthGrid,
  .CalendarMonth,
  .DayPicker {
    background-color: transparent !important;
  }

  .DateField {
    position: relative;
    transition: all 0.4s ease;
    background-color: transparent;
    border: 1px solid;
    //z-index: 8;
    min-height: rem(54px);
    @include respond-to(md) {
      z-index: 5;
    }
    .SingleDatePickerInput,
    .DateInput,
    .DateInput_input {
      background: transparent !important;
    }
    .CalendarIcon {
      svg {
        position: absolute;
        right: rem(${isRTL ? 'auto' : '10px'});
        left: rem(${isRTL ? '10px' : 'auto'});
        top: rem(17px);
        width: 18px;
        height: 17px;
        g {
          path {
            stroke: transparent !important;
          }
        }
      }
    }
  }

  .DateField__label {
    display: inline-block;
    position: absolute;
    top: rem(17px);
    left: rem(13px);
    transition: all 0.25s ease;
    z-index: 9;
    cursor: text;
    &.haveText {
      top: 6px;
      font-size: rem(12px);
    }
    &.active {
      top: 6px;
      font-size: rem(12px);
    }
  }

  .DateField__disabled {
    .DateField__label {
      cursor: default;
    }
    .CalendarIcon {
      svg {
        z-index: 10;
      }
    }
  }

  .DateField__error-text {
    width: 100%;
    display: inline-block;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .DateField__label {
      transition: none;
    }
  }

  @supports (-ms-ime-align: auto) {
    .DateField__label {
      transition: none;
    }
  }

  .DateField__mobile {
    border: none;
  }

  .DateField__schema {
    width: 30%;
    margin-right: 3.33%;
    @include respond-to(sm) {
      width: 48%;
      margin: 0;
    }
    .DateField__mobile {
      color: $body-background-color;
    }
  }

  .DateField__schema {
    .DateField__error {
      .DateField__mobile {
        color: $body-background-color !important;
        &::placeholder {
          color: $body-background-color !important;
        }
      }
    }
  }

  .DateField__presets {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: rem(20px);

    .DateField__time {
      width: 20px;
      height: 25px;
      padding: 0;
      border: none;
      border-radius: unset;
    }

    .DateField__time-caption {
      margin-right: rem(30px);
      font-size: rem(15px);
    }

    .DateField__time-separator {
      margin: rem(0 10px);
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .DateInput_input {
      &::placeholder {
        color: ${colors.white.hex};
      }
    }

    .DateField__mobile {
      color: ${colors.white.hex};
    }

    .DateInput_input,
    .SingleDatePicker,
    .DateInput,
    .SingleDatePickerInput {
      border-radius: ${border.radius};
      color: ${colors.black.hex};
    }

    .DateInput_input__focused {
      &::placeholder {
        color: ${colors.black.hex};
      }
    }

    .DateInput_input__disabled {
      background: ${colors.disabled.hex};
      color: ${colors.black.hex};
      -webkit-text-fill-color: ${colors.black.hex};
      &::placeholder {
        color: ${colors.disabled.hex} !important;
        -webkit-text-fill-color: ${colors.disabled.hex};
      }
    }

    .DateField {
      border-radius: ${border.radius};
      border-color: ${colors.lightGray.hex};
      &.active {
        border-color: ${colors.primary.hex};
        .DateField__mobile {
          color: ${colors.black.hex};
        }
        .CalendarIcon {
          svg {
            g {
              path {
                fill: ${colors.primary.hex};
              }
            }
            path {
              stroke: ${colors.primary.hex};
            }
          }
        }
      }
      &.haveText {
        .DateField__mobile {
          color: ${colors.black.hex};
        }
      }
    }

    .DateField__disabled {
      background: ${colors.disabled.hex};
      .DateField__mobile {
        background: ${colors.disabled.hex};
        color: ${colors.disabled.hex};
      }
      .CalendarIcon {
        svg {
          g {
            path {
              fill: ${colors.gray.hex};
            }
          }
          path {
            stroke: ${colors.gray.hex};
          }
        }
      }
      &.haveText {
        .DateField__mobile {
          color: ${colors.black.hex};
        }
      }
    }

    .DayPicker_weekHeader {
      color: ${colors.primary.hex};
    }

    .CalendarDay__selected {
      background: ${colors.primary.hex};
      border-color: ${colors.primary.hex};
      &:hover {
        background: ${colors.secondary.hex};
        border-color: ${colors.secondary.hex};
      }
    }

    .DateField__error {
      border-color: ${colors.error.hex} !important;
      .DateInput_input,
      .DateField__mobile {
        color: ${colors.white.hex} !important;
        &::placeholder {
          color: ${colors.white.hex} !important;
        }
      }
      .CalendarIcon {
        svg {
          g {
            path {
              fill: ${colors.error.hex};
            }
          }
          path {
            stroke: ${colors.error.hex};
          }
        }
      }
      .DateField__label {
        color: ${colors.error.hex} !important;
      }
    }

    .DateField__error {
      &.active {
        .DateInput_input__focused {
          color: ${colors.error.hex} !important;
          &::placeholder {
            color: ${colors.error.hex} !important;
          }
        }
        .DateInput_input {
          color: ${colors.error.hex} !important;
          &::placeholder {
            color: ${colors.error.hex} !important;
          }
        }
        .DateField__mobile {
          color: ${colors.error.hex} !important;
        }
        .CalendarIcon {
          svg {
            g {
              path {
                fill: ${colors.error.hex};
              }
            }
            path {
              stroke: ${colors.error.hex};
            }
          }
        }
      }
    }

    .DateField__label {
      color: ${colors.gray.hex};
      &.haveText {
        color: ${colors.gray.hex};
      }
      &.active {
        color: ${colors.primary.hex};
      }
    }

    .DateField__error-text {
      color: ${colors.error.hex};
    }

    .DateField__schema {
      .DateField.active {
        .DateField__mobile {
          color: ${colors.black.hex} !important;
        }
      }
      .DateField.haveText {
        .DateField__mobile {
          color: ${colors.black.hex} !important;
        }
      }
    }
    .DateField__time:focus {
      border-bottom: 1px solid;
      border-color: ${colors.lightGray.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
